/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
interface NotificationModalProps {
  showModal: boolean;
  notification: NotificationItem[];
  handleClose: () => void;
}

interface NotificationItem {
  title: string;
  description: string;
  time: string;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  showModal,
  notification,
  handleClose,
}) => {
  return (
    <div>
      <Modal show={showModal} className="p-10" onHide={handleClose}>
        <div className="w-250px w-lg-275px ">
          <div
            className="d-flex flex-column  rounded-top "
            style={{ padding: "20px", backgroundColor: "#5DA571" }}
          >
            <h3 className=" fw-bold text-white px-9 mt-10">Notifications</h3>
          </div>

          <div className="tab-content ">
            <div className="scroll-y mh-50px my-1 px-8 p-3">
              {notification?.length > 0 ? (
                notification?.map((item, i) => (
                  <div
                    className="card mb-2 "
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    <div
                      className="card-header p-2 d-flex align-items-center justify-content-between"
                      style={{ backgroundColor: "#E2E1E866" }}
                    >
                      <strong className="me-auto text-gray">
                        {item?.title}
                      </strong>
                      <small className="text-end ms-auto">{item?.time}</small>
                      {/* <button className="btn-close btm-sm text-end" onClick={() => handleClose(item?.id)}></button> */}
                    </div>
                    <div className="card-body  p-2">{item?.description}</div>
                  </div>
                ))
              ) : (
                <div className="text-center">
                  <div className="thumbnail">
                    <img
                      src="/assets/images/noDishes.svg"
                      style={{ height: "50px" }}
                    />
                  </div>
                  No notification
                </div>
              )}
            </div>

            <div
              className="tab-pane fade"
              id="kt_topbar_notifications_3"
              role="tabpanel"
            >
              <div className="scroll-y mh-325px my-5 px-8"></div>
              <div className="py-3 text-center border-top">
                <Link
                  to="/crafted/pages/profile"
                  className="btn btn-color-gray-600 btn-active-color-primary"
                >
                  View All
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Modal.Footer>
          <Button
            className="btn btn-cancel rounded-5 small me-2 mt-1"
            onClick={handleClose}
          >
            Clear
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NotificationModal;
